module.exports = __webpack_public_path__ + "static/img/RAPU-S_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPU-S_1.png
// module id = T7QS
// module chunks = 0